import { CircularProgress } from '@mui/material';

import DecisionStatusListDataTable from 'app/components/DataTable/decisionStatus/DecisionStatusListDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// tam okuma listesi 1,416
const DecisionStatusPage = () => {


    const [loading, setLoading] = useState(true);
    const params = useParams();
    const param = params.param;


    // useEffect(() => {
    //     const getAPI = async () => {
    //         setLoading(true);
    //         try {

    //         } catch (error) {
    //             console.error("Error in API call:", error);
    //         }
    //         setLoading(false);
    //     };
    //     getAPI();
    // }, [param]);


    const tableCellStyle = { fontSize: '10px' };
    const commonColumnStyle = { ...tableCellStyle, minWidth: 30, maxWidth: 50 };

    const columnData = [
        // { id: 'decisionNo', align: 'left', disablePadding: false, label: "Karar No", sx: commonColumnStyle },
        { id: 'inst', align: 'left', disablePadding: false, label: "Toplantı", sx: { ...tableCellStyle, maxWidth: 70 } },
        // { id: 'meetingNo', align: 'left', disablePadding: false, label: "Sayı", sx: commonColumnStyle },
        // { id: 'meetingDate', align: 'left', disablePadding: false, label: "Tarih", sx: commonColumnStyle },
        { id: 'department', align: 'left', disablePadding: false, label: "İlgili Kurum/Birim", sx: commonColumnStyle },
        { id: 'subject', align: 'left', disablePadding: false, label: "Konu", sx: { ...tableCellStyle, maxWidth: 50 } },
        { id: 'agenda', align: 'left', disablePadding: false, label: "Gündem", sx: { ...tableCellStyle, minWidth: 300, maxWidth: 350 } },
        { id: 'decision', align: 'left', disablePadding: false, label: "Karar", sx: { ...tableCellStyle, minWidth: 300, maxWidth: 350 } },
        { id: 'status', align: 'left', disablePadding: false, label: "Uygulanma Durumu", sx: { ...tableCellStyle, minWidth: 50, maxWidth: 50 } },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler", sx: { ...tableCellStyle, minWidth: 80, maxWidth: 100 } }
    ];

    return (
        <React.Fragment>


            <DecisionStatusListDataTable mainData={[]} column={columnData} type={param} />
        </React.Fragment>
    );
};

export default DecisionStatusPage;